import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useState } from 'react';
import { ExpandableSection } from 'foundations-components/transitional/components/ExpandableSection';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { H7 } from 'foundations-components/transitional/components/H7';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useTracker } from '../../context/hooks';
import { SeoRecommendationGroups } from '../constants';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GroupTitle = ({
  groupType
}) => {
  switch (groupType) {
    case SeoRecommendationGroups.CONTENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.content"
      });
    case SeoRecommendationGroups.CRAWLING_AND_INDEXING:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.crawlingAndIndexing"
      });
    case SeoRecommendationGroups.FORMS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.forms"
      });
    case SeoRecommendationGroups.HEADER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.header"
      });
    case SeoRecommendationGroups.IMAGES:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.images"
      });
    case SeoRecommendationGroups.LINKS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.links"
      });
    case SeoRecommendationGroups.META_DESCRIPTION:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.metaDescription"
      });
    case SeoRecommendationGroups.MOBILE_FRIENDLINESS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.mobileFriendliness"
      });
    case SeoRecommendationGroups.TITLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.title"
      });
    case SeoRecommendationGroups.TOPICS:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.topics"
      });
    case SeoRecommendationGroups.READABILITY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.groups.readability"
      });
    default:
      console.error(`No title translation found for group type ${groupType}`);
      return null;
  }
};
const Header = ({
  titleText,
  incompleteCount
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/_jsx(H7, {
      marginBlock: "0",
      children: titleText
    }), incompleteCount > 0 && /*#__PURE__*/_jsx(Badge, {
      use: "count",
      "data-test-id": "topic-editor-count-badge",
      children: incompleteCount
    }), incompleteCount === 0 && /*#__PURE__*/_jsx(IconCircle, {
      color: "fill-surface-default",
      backgroundColor: "fill-positive-default",
      icon: SuccessIcon,
      size: "200",
      padding: "25"
    })]
  });
};
export const GroupView = ({
  groupType,
  incompleteCount,
  children
}) => {
  const {
    track
  } = useTracker();
  const [open, setOpen] = useState(incompleteCount > 0);
  useEffect(() => {
    setOpen(incompleteCount > 0);
  }, [incompleteCount]);
  const handleOnOpenChange = () => {
    if (!open) {
      track('expandedRecommendationGroup', {
        group: groupType
      });
    }
    setOpen(!open);
  };
  const renderHeader = ({
    titleText
  }) => {
    return /*#__PURE__*/_jsx(Header, {
      titleText: titleText,
      incompleteCount: incompleteCount
    });
  };
  return /*#__PURE__*/_jsx(ExpandableSection, {
    "data-test-id": `xray-panel-group-${groupType}`,
    titleText: /*#__PURE__*/_jsx(GroupTitle, {
      groupType: groupType
    }),
    Title: renderHeader,
    open: open,
    onOpenChange: handleOnOpenChange,
    children: children
  });
};